module.exports = __webpack_public_path__ + "static/img/icon-13.5e0d097d.png";